import "./auth-pages.scss";

import { Form, Formik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { object } from "yup";

import { PasswordResetConfirm } from "pwapi";

import {
  wipe_password_confirm_reset,
  confirm_reset_password,
} from "shared/actions/authActions";

import BannerController from "components/BannerController";
import dotLogoSrc from "images/PathologyWatch_Dot_Logo_w Pw.png";
import ApplicationState from "store/ApplicationState";
import { AppDispatch } from "store/store";

import PasswordChangeFormFields, {
  passwordMatchSchema,
  PasswordRequirements,
} from "../PasswordChangeFormFields";
import ToastList from "../toasts/ToastList";

let schema = object().shape(passwordMatchSchema(true));

type ChangePasswordProps = {};

const ChangePasswordPage = (_props: ChangePasswordProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { detail, passwordIssues } = useSelector(
    ({ passwordResetConfirm }: ApplicationState) => passwordResetConfirm
  );
  const navigate = useNavigate();

  const { uid, token } = useParams<{ uid: string; token: string }>();

  useEffect(() => {
    dispatch(wipe_password_confirm_reset());
  }, []);

  return (
    <>
      <ToastList />
      <main className="auth-pages">
        <BannerController />
        <div className="auth-pages__content">
          <Link to="/">
            <figure className="DotLogo">
              <img src={dotLogoSrc} alt="dot. by PathologyWatch" />
            </figure>
          </Link>
          <span className="hr" />
          <h1>Please reset your password</h1>
          <h5>Password Requirements:</h5>
          <PasswordRequirements />
          <div className="form-div">
            <Formik
              initialValues={{
                new_password1: "",
                new_password2: "",
                uid: uid,
                token: token,
              }}
              validationSchema={schema}
              onSubmit={(values, { setSubmitting }) => {
                dispatch(
                  confirm_reset_password(
                    values as PasswordResetConfirm,
                    navigate
                  )
                );
                setSubmitting(false);
              }}
            >
              {({
                handleChange,
                isSubmitting,
                errors,
                touched,
                handleSubmit,
              }) => (
                <Form onSubmit={handleSubmit} translate="yes">
                  {passwordIssues &&
                    passwordIssues.length > 0 &&
                    passwordIssues.map((actualError: string) => (
                      <div className="alarm alarm-red">{actualError}</div>
                    ))}
                  {detail && (
                    <div className="alarm alarm-success">{detail}</div>
                  )}
                  <PasswordChangeFormFields
                    placeholders
                    handleChange={handleChange}
                    errors={errors}
                    touched={touched}
                  />
                  <div className="PageLayout">
                    <button
                      type="submit"
                      title="Reset Password"
                      className="Button--blue"
                      disabled={isSubmitting}
                    >
                      RESET PASSWORD
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <footer>
            <Link to="/">Back to Login</Link>
          </footer>
        </div>
      </main>
    </>
  );
};

export default ChangePasswordPage;
